import styled from 'styled-components'

import MessageBanner from 'LuxKit/Banners/MessageBanner'
import SolidStarIcon from 'LuxKit/Icons/solid/SolidStarIcon'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

const STAR_ICON = <SolidStarIcon />

// The banner sits flush against the room details above it and the rate tile below it,
// so it keeps square corners rather than the rebrand banner's default rounding.
const SquaredMessageBanner = styled(MessageBanner)`
  body.${REBRAND_PALETTE_CLASS} && {
    border-radius: 0;
  }
`

interface Props {
  message: string
}

function PropertyPopularRateBanner({ message }: Props) {
  return <SquaredMessageBanner kind="promotional" icon={STAR_ICON}>{message}</SquaredMessageBanner>
}

export default PropertyPopularRateBanner
